import { ExpenseKindEnum, Tax } from "@finway-group/shared/lib/models"
import { NO_TAX_RATE } from "../config/consts"
import { getDefaultTaxRateObject } from "./helper.utils"

export const getInitialTaxRate = (taxes: Array<Tax>, kind: ExpenseKindEnum) => {
    const defaultTax = getDefaultTaxRateObject(taxes)
    if (kind === ExpenseKindEnum.HOSPITALITY) {
        return defaultTax.taxRate === 0 ? defaultTax : { _id: NO_TAX_RATE }
    }
    return defaultTax
}
